<template>
  <b-card>
    <b-card-title
      class="text-center mb-1"
      :style="`color: ${cardTitle.color};`"
    >
      {{ cardTitle.text }}
    </b-card-title>
    <div class="card-task">
      <b-card-text
        v-for="(status , index) in statusData"
        :key="index"
        class="hover-in-card-text"
        style="margin-right: 5px;position: relative"
        draggable="true"
        @dragstart="onDragStart(status)"
        @click="openPopup(status.id)"
      >

        <div class="d-flex justify-content-between">
          <div>
            <!-- v-if="havePermission(status.created_by.name)" -->
            <b-avatar
              v-b-tooltip.hover
              class="cursor-default"
              :title="status.created_by.name"
              :variant="havePermission(status.created_by.name) ? 'primary' : 'secondary'"
              :size="30"
            />
          </div>
          <div>
            <b-badge
              variant="primary"
              :style="priorityColor(status.priority)"
            >
              {{ status.priority }}
            </b-badge>
          </div>

        </div>
        <p class="pt-1">
          {{ getTitle(status.issue) }}
        </p>
        <div
          v-if="havePermission(status.created_by.name)"
          class="d-flex justify-content-end"
          style="position: absolute; right: 8px; bottom: 8px;"
          @click.stop
        >
          <span
            class="hover-on-icon "
            @click="ationModalEdit(status.id)"
          >
            <feather-icon
              icon="EditIcon"
              color="primary"
              size="15"
            />
          </span>
          <span class="hover-on-icon">
            <DeleteTask
              :task-id="status.id"
              delete-url="https://gulftic-system.fci.group/api/task/created"
            />
          </span>
        </div>

      </b-card-text>

      <b-modal
        v-model="isModalVisible"
        :title="cardTitle.text"
        hide-footer
        scrollable
        size="xl"
      >
        <TaskDetailes :modal-id="modalId" />
      </b-modal>

      <b-modal
        v-model="isActionModalEdit"
        hide-footer
        hide-header
        scrollable
        size="lg"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
      >
        <b-row>
          <div class="d-flex justify-content-between align-items-center bg-light w-100 px-2 mb-1">
            <span class="font-weight-bold text-lg py-1">Edit Task</span>
            <feather-icon
              icon="XIcon"
              color="black"
              class="cursor-pointer"
              @click="closeModal()"
            />
          </div>
        </b-row>
        <AddEditTask
          :task-id="taskIdToEdit"
          @close-modal="closeModal()"
        />
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import DeleteTask from './DeleteTask.vue'
import TaskDetailes from './TaskDetails.vue'
import AddEditTask from './AddEditTask.vue'

export default {
  components: {
    DeleteTask,
    TaskDetailes,
    FeatherIcon,
    AddEditTask,
  },
  props: {
    cardTitle: {
      type: Object,
      required: true,
    },
    statusData: {
      type: Array,
      required: true,
    },

  },
  data() {
    return {
      isModalVisible: false,
      modalId: null,
      isActionModalEdit: false,
      taskIdToEdit: null,
    }
  },
  methods: {
    ationModalEdit(id) {
      this.isActionModalEdit = true
      this.taskIdToEdit = id
    },
    openPopup(id) {
      this.isModalVisible = true
      this.modalId = id
    },
    closeModal() {
      this.isActionModalEdit = false
    },
    getTitle(name) {
      const words = name.split(' ')
      if (words.length > 6) {
        return `${words.slice(0, 6).join(' ')}...`
      }
      return name
    },
    priorityColor(priority) {
      if (priority === 'high') {
        return {
          color: ' #DC2626',
          'background-color': '#FFE5E5',
          'font-size': 'smaller',
        }
      } if (priority === 'medium') {
        return {

          color: ' #D97706',
          'background-color': '#FFF4E5',
          'font-size': 'smaller',

        }
      }
      return {
        color: '#2563EB',
        'background-color': '#E0ECFF',
        'font-size': 'smaller',

      }
    },
    onDragStart(item) {
      this.$emit('dragstart', item, this.cardTitle.text)
    },
    havePermission(user) {
      const currentUser = localStorage.getItem('name')
      if (user === currentUser) {
        return true
      }
      return false
    },
  },
}
</script>

<style lang="scss">
.add-task-button{
  cursor: pointer;
  margin-top: 4px;
  padding-left: 8px;
  padding: 6px 0px;
  border-radius: 8px;
  span{
    margin-left: 8px;
  }
  &:hover{
    background-color: #e6e8eb;
  }
}
.card-task{
  max-height: 73vh;
  overflow-y: auto;
}
.card-task::-webkit-scrollbar {
    width: 8px;
    height: 6px;
  }

  .card-task::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  .card-task::-webkit-scrollbar-thumb {
    background: rgb(201, 201, 201);
    border-radius: 10px;
  }

  .card-task::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
.hover-in-card-text{
  background-color: #edeff3;
  padding: 8px 10px;
  border: 1px solid #d8d6de;
  border-radius: 15px;
}
.hover-in-card-text:hover {
  background-color: #e6e8eb;
  cursor: grab;
  p{
    transform: translateX(10px);
    transition: transform 0.3s ease-in-out;
  }
  .hover-on-icon{
    visibility: visible;
    transition:  transform 0.3s ease-in-out;
    transform: translatey(-3px);
  }
}
.hover-on-icon{
  padding: 2px 3px;
  border-radius: 5px;
  visibility: hidden;
}
.hover-on-icon:hover{
  cursor: pointer;
  background-color: #cccdcf;
}
</style>
